"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var StaffTypeCode;
(function (StaffTypeCode) {
    StaffTypeCode["Consultant"] = "CONSULTN";
    StaffTypeCode["CareerService"] = "CSERVICE";
    StaffTypeCode["ExternalConsultant"] = "EXTCNSLT";
    StaffTypeCode["OpsStaff"] = "OPSSTAFF";
    StaffTypeCode["SesManager"] = "SESMANG";
    StaffTypeCode["SmsManager"] = "SMSMANG";
})(StaffTypeCode = exports.StaffTypeCode || (exports.StaffTypeCode = {}));
